import { useDispatch, useSelector } from "react-redux";

import isProfessionActiveCategorySelector from "../../selectors/ProfessionSelectors/isProfessionActiveCategorySelector";
import toggleProfessionCategoryAction from "../../actions/ProfessionActions/toggleProfessionCategoryAction";
import { useCallback } from "react";

export default function useActiveCategoryToggle(term_id: number) {
    const dispatch = useDispatch();
    const isActiveCategory = useSelector((state: Store) => isProfessionActiveCategorySelector(state, term_id));
    const toggleProfessionCategory = useCallback(term_id => dispatch(toggleProfessionCategoryAction(term_id)), [dispatch]);
    return {
        isActiveCategory,
        toggleProfessionCategory
    };
}
